
import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { FontIcon } from "office-ui-fabric-react";

const classNames = mergeStyleSets({
    msg: {
        color: 'red',
        padding: '1em 0em',
        display: 'flex',
        flexDirection: 'row'
    },

    icon: {
        paddingTop: '0.2em'
    },

    msgDiv: {
        padding: '0em 1em'
    }
});

const UsekAttributesValidatorView = ({
    invalidUsekItems
}) => {

    const getInvalidUsekItemsText = () => {
        return invalidUsekItems.join(', ')
    }

    return (invalidUsekItems.length > 0)
        ?   <div className={classNames.msg}>
                <FontIcon className={classNames.icon} iconName="Warning"></FontIcon>
                <div className={classNames.msgDiv}> Následující úseky mezí nemají zadané všechny požadované atributy: {getInvalidUsekItemsText()} </div>
                <FontIcon className={classNames.icon} iconName="Warning"></FontIcon>
            </div>


        : null;
}

export default UsekAttributesValidatorView;
